
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 4c1.279 0 2.559.488 3.535 1.465L16 9l5 5-7 7-5.498-5.498c-.037.033-3.037-2.967-3.037-2.967A4.998 4.998 0 019 4m0-2c-1.87 0-3.628.729-4.949 2.051C2.729 5.371 2 7.129 2 8.999s.729 3.628 2.051 4.95l3 3c.107.107.227.201.35.279l5.187 5.186c.391.391.9.586 1.413.586s1.022-.195 1.414-.586l7-7c.78-.781.78-2.047 0-2.828l-5-5-3.45-3.521A6.971 6.971 0 009 2z"}}),_c('path',{attrs:{"d":"M9 7.498a1.5 1.5 0 110 3 1.5 1.5 0 010-3m0-1A2.503 2.503 0 006.5 9c0 1.377 1.121 2.498 2.5 2.498S11.5 10.377 11.5 9A2.503 2.503 0 009 6.498z"}})])
          )
        }
      }
    